export default __webpack_public_path__ + "static/media/cert-green2.f04881c5.svg";